/* eslint-disable
	@typescript-eslint/no-unsafe-call,
	@typescript-eslint/no-unsafe-assignment
*/
import { defineComponent, type PropType } from "vue";

import I18Next from "../I18Next";
import { defineI18NextStore } from "./I18NextStore";

/**
 * A store that knows about the currently active UI culture and initializes the i18next framework.
 */
export default defineComponent({
	name: "I18NextStoreRegistration",
	props: {
		/**
		 * Cache-busting / resource version for translation files.
		 */
		version: {
			type: String,
			required: true,
		},
		/**
		 * XHR endpoint used to load translation resources.
		 */
		xhr: {
			type: String,
			required: true,
		},
		/**
		 * Currently active UI culture.
		 */
		culture: {
			type: String,
			required: true,
		},
		/**
		 * Text resources embedded into the page HTML for i18next to seed without an XHR.
		 */
		embeddedTextResources: {
			type: Object as PropType<Record<string, string>>,
			required: true,
		},
		/**
		 * localStorage cache TTL for translation entries, in milliseconds.
		 */
		cacheExpirationTimeMs: {
			type: Number,
			required: true,
		},
		/**
		 * MultiloadAdapter debounce before coalesced XHR loads, in milliseconds.
		 */
		multiloadDebounceMs: {
			type: Number,
			required: true,
		},
	},
	created() {
		const i18nextStore = defineI18NextStore(
			this.culture,
			this.xhr,
			this.version,
			this.cacheExpirationTimeMs,
			this.multiloadDebounceMs,
		);
		void I18Next.initialize(i18nextStore(), this.embeddedTextResources);
	},
	/**
	 * A render function is required when a Vue component lacks a `<template>`.
	 * Since this is a logical component with no rendered DOM elements, we return `undefined`
	 * to prevent errors or warnings.
	 */
	render() {
		return undefined;
	},
});
